import StarterKit from '@tiptap/starter-kit'
import { Extensions } from '@tiptap/core'

import { HiddenLinkMark, PlaceholderMark } from './marks'

/**
 * The editor schema, deliberately narrow.
 *
 * This replaces the old `draftjs-filters` allow-list: ProseMirror validates
 * against the schema when parsing pasted HTML, so anything not declared here
 * (headings, tables, images, colours, font sizes, Word cruft) is dropped
 * automatically instead of needing a separate filtering pass.
 *
 * Kept out of ./index so that store/selector code can use the HTML helpers
 * without pulling the whole editor into its bundle (and into its tests).
 */
export const richTextExtensions = (): Extensions => [
  StarterKit.configure({
    blockquote: false,
    code: false,
    codeBlock: false,
    heading: false,
    horizontalRule: false,
    strike: false,
    // Links are a supported feature: writers send the template-library link to
    // SL clients, and the old editor's filter allow-listed LINK entities.
    // Setting this to false stripped every <a href> on paste and template
    // insertion (CCB-5714).
    //
    // Parity with the old editor: it had no link button and did not turn typed
    // or pasted URLs into links, so autolink/linkOnPaste stay off. Links only
    // arrive already marked up (templates, snippets, pasted HTML). openOnClick
    // is off so clicking a link while composing does not navigate away.
    //
    // TipTap adds target="_blank" rel="noopener noreferrer nofollow" to every
    // link by default. The old editor sent links exactly as authored, so those
    // defaults are cleared; a target present in the source HTML is still kept.
    link: {
      openOnClick: false,
      autolink: false,
      linkOnPaste: false,
      HTMLAttributes: { target: null, rel: null },
    },
    underline: false,
  }),
  PlaceholderMark,
  HiddenLinkMark,
]
